<template>
    <div :style="styleDynamicElement(el)" :class="el.getAnimationClass(currentElementIndex)" @mousedown="eventDrag($event, el.previewId)">
        <div :style="el.getStyle()"></div>
        <!-- <ShadowMedia v-if="el.Shadow" :el="el.Shadow"/> -->
    </div>
</template>

<script>
import BasePreviewComponents from "./base/basePreviewComponents.vue";
import ShadowMedia from "./shadow.vue";
export default {
    name: 'ColorMedia',
    extends: BasePreviewComponents,
    components: {
        ShadowMedia
    },
    methods: {
    }
}
</script>



